import axios from 'axios';

const API_BASE_URL = '/api';

class BookingService {
  async importBookings(file, facilityId, bookingDate) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('facility_id', facilityId);
    formData.append('booking_date', bookingDate);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/bookings/import`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error importing bookings:', error);
      throw error;
    }
  }

  async getAllBookings(filters = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filters.date) {
        params.append('date', filters.date);
      }
      if (filters.facility_id) {
        params.append('facility_id', filters.facility_id);
      }
      if (filters.status_id) {
        params.append('status_id', filters.status_id);
      }
      if (filters.active !== undefined) {
        params.append('active', filters.active);
      }

      const response = await axios.get(`${API_BASE_URL}/bookings?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching bookings:', error);
      throw error;
    }
  }

  async getBookingsDetailed(filters = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filters.date) {
        params.append('date', filters.date);
      }
      if (filters.facilityId) {
        params.append('facility_id', filters.facilityId);
      }
      if (filters.statusId) {
        params.append('status_id', filters.statusId);
      }
      if (filters.active !== undefined) {
        params.append('active', filters.active);
      }

      const response = await axios.get(`${API_BASE_URL}/bookings/detailed?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching detailed bookings:', error);
      throw error;
    }
  }

  async getBookingStatuses() {
    try {
      const response = await axios.get(`${API_BASE_URL}/booking-statuses`);
      return response.data;
    } catch (error) {
      console.error('Error fetching booking statuses:', error);
      throw error;
    }
  }

  async updateBookingStatus(id, statusId) {
    try {
      const response = await axios.put(`${API_BASE_URL}/bookings/${id}`, { status_id: statusId });
      return response.data;
    } catch (error) {
      console.error('Error updating booking status:', error);
      throw error;
    }
  }

  async getBookingById(id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/bookings/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching booking:', error);
      throw error;
    }
  }

  async createBooking(bookingData) {
    try {
      const response = await axios.post(`${API_BASE_URL}/bookings`, bookingData);
      return response.data;
    } catch (error) {
      console.error('Error creating booking:', error);
      throw error;
    }
  }

  async updateBooking(id, bookingData) {
    try {
      const response = await axios.put(`${API_BASE_URL}/bookings/${id}`, bookingData);
      return response.data;
    } catch (error) {
      console.error('Error updating booking:', error);
      throw error;
    }
  }

  async deleteBooking(id) {
    try {
      await axios.delete(`${API_BASE_URL}/bookings/${id}`);
    } catch (error) {
      console.error('Error deleting booking:', error);
      throw error;
    }
  }
}

export default new BookingService();